// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionMap, ITraduccionMapKeys, TraduccionMap} from "services-translation/modules/base/traduccion/map";

import idiomas from "./_idiomas";

export type TraduccionCmpGdprDataP3Params = Record<"url_cookies" | "url_privacidad", string>;

export interface ITraduccionCmpGdprDataP3Keys extends ITraduccionMapKeys {
    "app": string;
    "web": string;
}

export class TraduccionCmpGdprDataP3 extends TraduccionMap<TraduccionCmpGdprDataP3Params> {
    /* STATIC */
    protected static override readonly ID: string = "cmp.gdpr.data_p3";
    private static VALUES?: ITraduccionMap;

    public static override build(lang: IIdioma): TraduccionCmpGdprDataP3 {
        this.VALUES ??= this.completar({
            "valor": {
                "da": {
                    "valores": {
                        "app": "Du kan konsultere vores <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_privacidad}}\">Privatlivspolitik</a>. Når samtykke er konfigureret, kan du få adgang til appens annonceringsindstillinger for at ændre præferencerne.",
                        "web": "Når samtykke er konfigureret, kan du få adgang til vores <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_cookies}}\">cookiepolitikside</a> for at ændre præferencerne."
                    }
                },
                "de": {
                    "valores": {
                        "app": "Sie können unsere <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_privacidad}}\">Datenschutzrichtlinie</a> einsehen. Sobald die Zustimmungen konfiguriert sind, können Sie sie durch Zugriff auf die Anzeigeneinstellungen in den App-Einstellungen ändern.",
                        "web": "Sobald Sie Ihre Zustimmung gegeben haben, können Sie auf unsere <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_cookies}}\">Cookie-Richtlinien-Seite</a>, um Ihre Einstellungen zu ändern"
                    }
                },
                "en": {
                    "valores": {
                        "app": "You can consult our <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_privacidad}}\">Privacy Policy</a>. Once the consents are configured, you can modify them by accessing the ad settings in the app preferences.",
                        "web": "Once the consents have been configured, you can access our <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_cookies}}\">cookie policy page</a> to modify the preferences.</p></span>"
                    }
                },
                "es": {
                    "valores": {
                        "app": "Puedes consultar nuestra <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_privacidad}}\">Política de Privacidad</a>. Una vez configurados los consentimientos, podrás modificarlos accediendo a la configuración de anuncios en las preferencias de la app.",
                        "web": "Una vez configurados los consentimientos, podrás acceder a nuestra <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_cookies}}\">página de política de cookies</a> para modificar las preferencias."
                    }
                },
                "fr": {
                    "valores": {
                        "app": "Vous pouvez consulter notre <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_privacidad}}\">politique de confidentialité</a>. Une fois les consentements paramétrés, vous pouvez les modifier en accédant aux paramètres des publicités dans les préférences de l'application.",
                        "web": "Vous pouvez changer d\\'avis et modifier vos préférences à tout moment en accédant à notre <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_cookies}}\">politique de cookies</a>."
                    }
                },
                "it": {
                    "valores": {
                        "app": "Puoi consultare la nostra <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_privacidad}}\">Privacy Policy</a>. Una volta configurati i consensi, potrai modificarli accedendo alle impostazioni degli annunci nelle preferenze della app.",
                        "web": "Una volta configurati i consensi, puoi accedere alla nostra <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_cookies}}\">pagina di Cookie Policy</a> per modificare le preferenze."
                    }
                },
                "nl": {
                    "valores": {
                        "app": "Je kan hier ons <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_privacidad}}\">privacybeleid</a> raadplegen. Zodra de voorkeuren éénmaal zijn ingesteld, kan je deze weer aanpassen door de reclame-instellingen aan te passen in de instellingensectie van de applicatie.",
                        "web": "Als u uw toestemmingen heeft geconfigureerd kunt u deze ten alle tijde onze <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_cookies}}\">cookiebeleidspagina</a> gaan om uw voorkeuren te wijzigen."
                    }
                },
                "pt": {
                    "valores": {
                        "app": "Pode consultar a nossa <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_privacidad}}\">Política de Privacidade</a>. Depois de configurar os seus consentimentos, pode modificá-los acedendo às definições de anúncios nas preferências da aplicação.",
                        "web": "Uma vez configurados os consentimentos, poderá aceder à nossa <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_cookies}}\">página de política de cookies</a> para modificar as preferências."
                    }
                },
                "ru": {
                    "valores": {
                        "app": "Вы можете ознакомиться с нашей <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_privacidad}}\">Политикой конфиденциальности</a>. После того, как согласия будут настроены, вы можете изменить их, открыв настройки рекламы в настройках приложения.",
                        "web": "После настройки соглашений, вы получаете доступ к <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_cookies}}\">странице политики Cookies</a>, где можете изменить настройки.>"
                    }
                },
                "pt-BR": {
                    "valores": {
                        "app": "Pode consultar a nossa <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_privacidad}}\">Política de Privacidade</a>. Depois de configurados os consentimentos, você pode modificá-los acessando as configurações de anúncios nas preferências do aplicativo.",
                        "web": "Assim que os consentimentos forem configurados, você pode acessar nossa <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_cookies}}\">página de política de cookies</a> para modificar as preferências."
                    }
                },
                "ca": {
                    "valores": {
                        "app": "Pots consultar la nostra <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_privacidad}}\">Política de Privacitat</a>. Un cop configurats els consentiments, podreu modificar-los accedint a la configuración d'anuncis a les preferències de l'app.",
                        "web": ""
                    }
                },
                "eu": {
                    "valores": {
                        "app": "Gure <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_privacidad}}\">Pribatutasun Politika</a> kontsulta dezakezu. Behin baimenak konfiguratuta, alda ditzakezu aplikazioaren hobespenetako iragarkien ezarpenetara sartuz.",
                        "web": ""
                    }
                },
                "gl": {
                    "valores": {
                        "app": "Podes consultar a nosa <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_privacidad}}\">Política de Privacidade</a>. Unha vez configurados os consentimentos, podes modificalos accedendo á configuración de anuncios nas preferencias da aplicación.",
                        "web": ""
                    }
                },
                "fi": {
                    "valores": {
                        "app": "Voit tutustua <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_privacidad}}\">tietosuojakäytäntöömme</a>. Kun suostumukset on määritetty, voit muokata niitä siirtymällä sovellusasetusten mainosasetuksiin.",
                        "web": ""
                    }
                },
                "hi": {
                    "valores": {
                        "app": "आप हमारी <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_privacidad}}\">गोपनीयता नीति</a> से परामर्श ले सकते हैं। एक बार सहमति कॉन्फ़िगर हो जाने के बाद, आप ऐप प्राथमिकताओं में विज्ञापन सेटिंग्स तक पहुंच कर उन्हें संशोधित कर सकते हैं।",
                        "web": ""
                    }
                },
                "hu": {
                    "valores": {
                        "app": "Megtekintheti <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_privacidad}}\">adatvédelmi szabályzatunkat</a>. A hozzájárulások konfigurálása után módosíthatja azokat az alkalmazásbeállítások hirdetésbeállításainak megnyitásával.",
                        "web": ""
                    }
                },
                "no": {
                    "valores": {
                        "app": "Du kan se vår <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_privacidad}}\">personvernerklæring</a>. Når samtykkene er konfigurert, kan du endre dem ved å gå til annonseinnstillingene i appinnstillingene.",
                        "web": ""
                    }
                },
                "pl": {
                    "valores": {
                        "app": "Możesz zapoznać się z naszą <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_privacidad}}\">Polityką prywatności</a>. Po skonfigurowaniu zgód możesz je modyfikować, przechodząc do ustawień reklam w preferencjach aplikacji.",
                        "web": ""
                    }
                },
                "ro": {
                    "valores": {
                        "app": "Puteți consulta <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_privacidad}}\">Politica noastră de confidențialitate</a>. Odată configurate consimțământurile, le puteți modifica accesând setările de anunțuri din preferințele aplicației.",
                        "web": ""
                    }
                },
                "cs": {
                    "valores": {
                        "app": "Můžete si přečíst naše <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_privacidad}}\">Zásady ochrany osobních údajů</a>. Jakmile jsou souhlasy nakonfigurovány, můžete je upravit v nastavení reklam v předvolbách aplikace.",
                        "web": ""
                    }
                },
                "sk": {
                    "valores": {
                        "app": "Môžete si prečítať naše <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_privacidad}}\">Zásady ochrany osobných údajov</a>. Po nakonfigurovaní súhlasov ich môžete upraviť v nastaveniach reklamy v predvoľbách aplikácie.",
                        "web": ""
                    }
                },
                "sv": {
                    "valores": {
                        "app": "Du kan läsa vår <a id=\"url-policy\" href=\"javascript:void(0)\" data-link=\"{{url_privacidad}}\">integritetspolicy</a>. När samtyckena är konfigurerade kan du ändra dem genom att komma åt annonsinställningarna i appinställningarna.",
                        "web": ""
                    }
                }
            }
        }, idiomas);

        return super.build(lang, this.VALUES, ["url_cookies","url_privacidad"]);
    }

    /* INSTANCE */
}
